/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type TemperatureBadge_DisplayFragment = { __typename: 'Display', id: string, temperatureUpdatedAt?: any | null, temperatureThreshold?: { __typename: 'TemperatureThreshold', maxWarning: number, max: number } | null, temperatures?: Array<{ __typename: 'Temperature', sensorId?: string | null, isSensorPresent?: boolean | null, value?: number | null, degrees?: string | null, unit: string }> | null };

export const TemperatureBadge_DisplayFragmentDoc = gql`
    fragment TemperatureBadge_display on Display {
  id
  temperatureThreshold {
    maxWarning
    max
  }
  temperatures {
    sensorId
    isSensorPresent
    value
    degrees
    unit
  }
  temperatureUpdatedAt
}
    `;